import api from 'globals/infra/adapter';

const makeAuth = async (body: string) => {
  return api
    .post(`${process.env.NEXT_PUBLIC_WIT_CORE_OAUTH}/token`, body, {
      'headers': {
        'Content-Type': 'application/json',
      },
    })
    .catch((err) => {
      if (!err.response) {
        throw 'Sistema indisponível, tente novamente em alguns minutos';
      }

      const { status } = err.response;
      throw 'Usuário ou senha inválidos';
    });
};

module.exports = { makeAuth };
